import { IMG } from "./site";

export const SERVICE_PAGES = [
    {
        slug: "/changement-de-serrure",
        name: "Changement de serrure",
        price: "dès 85€",
        metaTitle: "Changement de Serrure Paris dès 85€ | Serrurier Agréé 24/7",
        metaDesc: "Changement de serrure à Paris dès 85€ (main d'œuvre) : toutes marques Fichet, Bricard, JPM, Vachette. Artisan agréé assurance, intervention 30 min, devis gratuit. ☎ 06 25 25 86 19",
        heroIntro: "Perte de clés, cambriolage, déménagement ou serrure usée : nos artisans remplacent votre serrure dans les règles de l'art, toutes marques, sur Paris et toute l'Île-de-France.",
        includes: [
            "Remplacement de serrure 3, 5 et 7 points",
            "Cylindre européen haute sécurité",
            "Serrures Fichet, Bricard, JPM, Vachette, DOM",
            "Justificatif de domicile systématiquement demandé",
            "Devis gratuit avant intervention",
            "Garantie décennale sur la pose",
        ],
        block1: {
            img: IMG("serrurier-ouverture-de-porte.webp"),
            kicker: "Quand changer sa serrure ?",
            title: "Les situations qui exigent un remplacement",
            paras: [
                "Après une perte ou un vol de clés, un cambriolage ou une tentative d'effraction, le changement de serrure est indispensable pour retrouver une sécurité totale. Un déménagement est également le moment idéal : impossible de savoir combien de doubles circulent encore.",
                "Une serrure qui résiste, qui grince ou dont la clé tourne mal annonce souvent une panne imminente. Remplacer avant la casse vous évite une urgence plus coûteuse.",
            ],
        },
        block2: {
            img: IMG("serrurier-fichet-Paris.webp"),
            kicker: "Toutes marques, tous modèles",
            title: "Un remplacement adapté à votre porte",
            paras: [
                "Nos serruriers montent et changent tous les types de serrures : serrures 3 à 7 points, cylindres européens, verrous, gâches électriques, sur portes en bois, PVC, aluminium ou blindées.",
                "Nous travaillons avec les plus grandes marques — Fichet, Bricard, JPM, Vachette, DOM, Reelax — et nous vous orientons vers le niveau de sécurité adapté à votre logement et aux exigences de votre assurance.",
            ],
        },
        note: "Main d'œuvre changement de serrure : 85€. Le prix de la serrure dépend du modèle choisi — un devis gratuit et détaillé vous est remis avant toute intervention.",

        faq: [
            {
                q: "Combien coûte un changement de serrure à Paris ?",
                a: "La main d'œuvre pour un changement de serrure démarre à 85 € TTC. Le prix total dépend du cylindre choisi : un cylindre d'entrée de gamme coûte entre 30 et 60 €, un cylindre haute sécurité A2P BP2 entre 80 et 150 €. Un devis détaillé (pièces + main-d'œuvre séparés) vous est remis avant intervention.",
            },
            {
                q: "Faut-il changer la serrure après un cambriolage ?",
                a: "Oui, impérativement. Un cylindre forcé ou tenté d'effraction est mécaniquement compromis. De plus, les cambrioleurs reviennent parfois quelques semaines plus tard sur les mêmes cibles. Le remplacement par un cylindre A2P BP2 ou BP3 dissuade la grande majorité des intrusions.",
            },
            {
                q: "Peut-on changer seulement le cylindre sans changer toute la serrure ?",
                a: "Dans la plupart des cas, oui. Le cylindre (le mécanisme qui reçoit la clé) se change indépendamment de la serrure (le boîtier). C'est la solution la plus économique : quelques minutes d'intervention, pour un résultat identique à un remplacement complet. Si le boîtier lui-même est endommagé, le remplacement intégral est nécessaire.",
            },
            {
                q: "Quelles marques de serrures installez-vous ?",
                a: "Nous installons toutes les grandes marques : Fichet, Bricard, JPM, Vachette, DOM, Mul-T-Lock, Reelax et Abloy. Nous vous conseillons le niveau de sécurité adapté à votre logement et aux exigences de votre assurance habitation.",
            },
            {
                q: "Le changement de serrure est-il remboursé par l'assurance ?",
                a: "Oui, si vous avez une garantie « vol » ou « assistance » dans votre contrat multirisques. Après un cambriolage, portez plainte et conservez le récépissé. Notre facture détaillée (SIRET, TVA, détail pièces et main-d'œuvre) est conforme aux exigences des assureurs.",
            },
        ],
    },
    {
        slug: "/porte-blindee",
        name: "Porte blindée & blindage",
        price: "sur devis",
        metaTitle: "Porte Blindée & Blindage de Porte Paris | Devis Gratuit — Serrurier",
        metaDesc: "Blindage de porte et pose de porte blindée à Paris : sécurisation certifiée A2P, serrure 3 à 7 points. Étude gratuite, artisan agréé assurance. ☎ 06 25 25 86 19",
        heroIntro: "Un cambriolage a lieu toutes les deux minutes en France. Le blindage de votre porte est la protection la plus efficace : nos experts vous conseillent la solution adaptée à votre logement et à votre budget.",
        includes: [
            "Blindage de votre porte existante",
            "Pose de porte blindée complète",
            "Serrures 3 à 7 points certifiées A2P",
            "Corniches anti-pince et protège-gonds",
            "Étude de sécurité gratuite à domicile",
            "Conforme aux exigences des assurances",
        ],
        block1: {
            img: IMG("serrurier-paris.paris.webp"),
            kicker: "Deux solutions",
            title: "Blindage ou porte blindée complète ?",
            paras: [
                "Le blindage consiste à renforcer votre porte actuelle avec une tôle d'acier, des corniches anti-pince et une serrure multipoints : une solution efficace et plus économique qui préserve l'esthétique de votre porte.",
                "La porte blindée complète offre le niveau de protection maximal : bloc-porte certifié, serrure de haute sécurité intégrée et isolation renforcée. Idéale après un cambriolage ou pour un bien de valeur.",
            ],
        },
        block2: {
            img: IMG("serrure-depannage-paris.webp"),
            kicker: "Conseil d'experts",
            title: "Une sécurité pensée pour durer",
            paras: [
                "Vérifier la fiabilité de vos portes et la qualité de vos serrures fait partie des conseils que nous prodiguons lors de chaque intervention. Un dispositif anti-vol bien choisi décourage la grande majorité des cambrioleurs.",
                "Nos installations respectent les exigences des compagnies d'assurance : en cas de sinistre, votre conformité facilite l'indemnisation.",
            ],
        },
        note: "Le blindage et la porte blindée sont établis sur devis après étude gratuite de votre porte et de votre niveau de sécurité souhaité.",

        faq: [
            {
                q: "Quelle est la différence entre le blindage et une porte blindée ?",
                a: "Le blindage consiste à renforcer votre porte actuelle avec une tôle d'acier, des corniches anti-pince et une serrure multipoints. La porte blindée est un bloc-porte complet : châssis acier, remplissage anti-effraction et serrure haute sécurité intégrée. Le blindage est plus économique (à partir de 600 €) ; la porte blindée offre une protection maximale (à partir de 1 500 €).",
            },
            {
                q: "Que signifie la certification A2P pour une porte blindée ?",
                a: "La certification A2P (Assurance Prévention Protection) est délivrée par le CNPP après des tests de résistance à l'effraction chronométrés. BP1 résiste 10 minutes, BP2 résiste 20 minutes, BP3 résiste 30 minutes. La plupart des assureurs exigent une porte A2P BP1 minimum pour accorder la garantie vol.",
            },
            {
                q: "Faut-il l'accord du propriétaire ou de la copropriété ?",
                a: "Pour un appartement en copropriété, le remplacement de la porte d'entrée (qui est souvent un élément commun côté palier) peut nécessiter l'accord du syndic. Nous pouvons vous accompagner dans cette démarche. Pour une maison individuelle, aucune autorisation n'est nécessaire.",
            },
            {
                q: "Combien de temps dure la pose d'une porte blindée ?",
                a: "La pose d'une porte blindée dure généralement une demi-journée (3 à 4 heures) pour un appartement standard. La dépose de l'ancienne porte, la pose du nouveau bloc-porte et les finitions sont incluses. Votre logement est sécurisé le jour même.",
            },
        ],
    },
    {
        slug: "/rideau-metallique",
        name: "Rideau métallique",
        price: "sur devis",
        metaTitle: "Dépannage Rideau Métallique Paris 24/7 | Déblocage & Réparation",
        metaDesc: "Rideau métallique bloqué à Paris : dépannage, déblocage et réparation pour commerces, boutiques et locaux. Intervention rapide 24h/24, devis gratuit et transparent. ☎ 06 25 25 86 19",
        heroIntro: "Rideau métallique bloqué, moteur en panne, lame cassée : votre commerce ne peut pas rester fermé. Nos techniciens interviennent 24h/24 sur Paris et l'Île-de-France pour débloquer et réparer votre rideau de fer.",
        includes: [
            "Déblocage de rideau métallique coincé",
            "Réparation et remplacement de moteur",
            "Remplacement de lames et d'axes",
            "Ouverture de rideau après effraction",
            "Fabrication et installation sur mesure",
            "Entretien préventif pour commerces",
        ],
        block1: {
            img: IMG("serrurier-ouverture-de-porte.webp"),
            kicker: "Urgence commerces",
            title: "Un rideau bloqué ne peut pas attendre",
            paras: [
                "Un rideau métallique bloqué en position fermée empêche l'ouverture de votre boutique ; bloqué ouvert, il laisse votre local sans protection. Dans les deux cas, nos équipes interviennent en urgence, de jour comme de nuit.",
                "Notre service d'ouverture de rideau métallique fonctionne 24h/24 et 7j/7, y compris le dimanche et les jours fériés, pour sécuriser votre activité au plus vite.",
            ],
        },
        block2: {
            img: IMG("entretien-regulier-serrurerie.webp"),
            kicker: "Réparation & fabrication",
            title: "De la réparation à la fabrication sur mesure",
            paras: [
                "Remplacement de lames endommagées, d'axes, de ressorts, de serrures de rideau ou de motorisation complète : nous réparons toutes les configurations, manuelles comme motorisées.",
                "Pour les commerces et locaux professionnels, nous assurons également la fabrication, l'installation et la pose de rideaux métalliques sur mesure, ainsi qu'un entretien préventif qui évite les pannes.",
            ],
        },
        note: "Le dépannage de rideau métallique est établi sur devis gratuit selon la panne : mécanique, serrure ou motorisation.",

        faq: [
            {
                q: "Pourquoi mon rideau métallique est-il bloqué ?",
                a: "Les causes les plus fréquentes sont : un ressort cassé (le ressort de tension accumule des cycles jusqu'à la rupture), un lame tordue qui coince dans le guide, un problème électrique sur le moteur, une serrure de rideau défectueuse, ou une accumulation de salissures dans les rails. Nos techniciens diagnostiquent la panne sur place et vous proposent une solution adaptée.",
            },
            {
                q: "Peut-on ouvrir un rideau métallique manuellement quand le moteur est en panne ?",
                a: "Oui, dans la plupart des cas. Les rideaux motorisés disposent d'un déverrouillage manuel de secours (clé de déverrouillage ou manivelle). Si ce mécanisme est bloqué ou manquant, notre technicien peut forcer l'ouverture sans endommager la lame. L'accès à votre local est rétabli immédiatement.",
            },
            {
                q: "Quel est le délai d'intervention pour un rideau bloqué ?",
                a: "Nous intervenons en urgence 24h/24 sur Paris et l'Île-de-France. Le délai moyen est de 30 à 45 minutes. Pour les commerces en zone centrale (1er au 10ème), nous arrivons souvent en 20 minutes. Un rideau bloqué la nuit ou le week-end bénéficie du même délai.",
            },
            {
                q: "Faites-vous la fabrication de rideaux métalliques sur mesure ?",
                a: "Oui. Nous fabriquons et installons des rideaux à tirage direct, à lames articulées ou perforées, manuels ou motorisés. Nous intervenons pour les boutiques, restaurants, garages et locaux professionnels. Devis gratuit sur place après prise de mesures.",
            },
        ],
    },
    {
        slug: "/coffre-fort",
        name: "Coffre-fort",
        price: "dès 150€",
        metaTitle: "Ouverture & Installation Coffre-Fort Paris dès 150€ | Serrurier Expert",
        metaDesc: "Coffre-fort Paris : ouverture dès 150€ si combinaison oubliée, clé perdue ou mécanisme bloqué. Installation et scellement de coffres certifiés. Devis gratuit. ☎ 06 25 25 86 19",
        heroIntro: "Combinaison oubliée, clé perdue, mécanisme bloqué : nos experts ouvrent votre coffre-fort sans abîmer son contenu, et installent des coffres certifiés pensés pour durer.",
        includes: [
            "Ouverture de coffre-fort bloqué",
            "Combinaison oubliée ou clé perdue",
            "Installation et scellement au sol ou au mur",
            "Coffres certifiés A2P",
            "Conseil sur le niveau de protection",
            "Justificatif de propriété demandé",
        ],
        block1: {
            img: IMG("serrure-depannage-paris.webp"),
            kicker: "Ouverture experte",
            title: "Ouvrir sans dégrader le contenu",
            paras: [
                "L'ouverture d'un coffre-fort demande un savoir-faire spécifique : manipulation de la combinaison, perçage ciblé du mécanisme, crochetage des serrures à clé. Nos techniciens privilégient toujours la technique la moins destructive.",
                "Comme pour un changement de serrure, un justificatif de propriété vous sera demandé avant toute ouverture — une mesure de sécurité indispensable.",
            ],
        },
        block2: {
            img: IMG("serrurier-paris.paris.webp"),
            kicker: "Installation",
            title: "Une protection maximale, pensée pour durer",
            paras: [
                "Bijoux, documents, espèces : un coffre-fort correctement scellé est la dernière ligne de défense de vos biens. Nous vous conseillons sur le volume, la certification et l'emplacement idéal.",
                "Scellement au sol ou au mur, coffre ignifuge, serrure électronique ou mécanique : nous installons des solutions adaptées aux particuliers comme aux professionnels.",
            ],
        },
        note: "Ouverture de coffre-fort : à partir de 150€. Installation et fourniture sur devis gratuit après étude de vos besoins.",

        faq: [
            {
                q: "Comment ouvrir un coffre-fort dont on a oublié le code ?",
                a: "Selon le type de coffre, nos techniciens utilisent plusieurs méthodes : la manipulation de combinaison (écoute des mécanismes sans destruction), le perçage ciblé sur un point précis du mécanisme, ou le remplacement des piles si c'est un coffre électronique. Nous choisissons toujours la technique la moins destructive. Un justificatif de propriété est exigé avant toute ouverture.",
            },
            {
                q: "Intervenez-vous sur toutes les marques de coffre-fort ?",
                a: "Oui. Nous intervenons sur les principales marques : Fichet, Hartmann, Chubbsafes, Burg-Wächter, Sentry, Stark, G-Consult et autres. Pour les coffres de marque ancienne ou hors commerce, nous évaluons la faisabilité gratuitement par téléphone.",
            },
            {
                q: "Que faire si la serrure électronique de mon coffre ne répond plus ?",
                a: "Avant d'appeler un serrurier, vérifiez l'état des piles (les coffres électroniques ont souvent une alimentation externe de secours par piles 9V à l'extérieur). Si le problème persiste, la carte électronique ou le mécanisme de verrouillage est défaillant — appelez-nous pour un diagnostic.",
            },
            {
                q: "Comment sceller un coffre-fort pour qu'il soit difficile à emporter ?",
                a: "Un coffre non ancré peut être emporté entier par des cambrioleurs même s'il est lourd. Nous scellons votre coffre dans le sol ou dans une cloison avec des chevilles chimiques ou des boulons traversants. Cette fixation est incluse dans l'installation.",
            },
        ],
    },
    {
        slug: "/double-de-cle",
        name: "Double de clé",
        price: "dès 5€",
        metaTitle: "Double de Clé Paris dès 5€ | Reproduction Toutes Marques — Serrurier",
        metaDesc: "Double de clé Paris dès 5€ : reproduction de clés plates, à points, cartes de propriété, toutes marques Fichet, Bricard, Vachette. Service rapide. ☎ 06 25 25 86 19",
        heroIntro: "Besoin d'un double pour un proche, un locataire ou en prévention d'une perte ? Nous reproduisons vos clés rapidement, toutes marques, avec la précision d'un artisan.",
        includes: [
            "Clés plates et clés à points",
            "Clés de serrures 3 à 7 points",
            "Toutes marques : Fichet, Bricard, Vachette, DOM…",
            "Clés protégées sur présentation de la carte de propriété",
            "Reproduction rapide sur place",
            "Conseil sur le nombre de doubles en circulation",
        ],
        block1: {
            img: IMG("serrurier-fichet-Paris.webp"),
            kicker: "Toutes marques",
            title: "Une reproduction fidèle, toutes marques",
            paras: [
                "Un double de clé approximatif use prématurément votre serrure et finit par coincer. Nos reproductions sont réalisées avec des machines de précision, pour un fonctionnement identique à l'originale.",
                "Clé plate : 5€, clé à gorges : 11€, clé spéciale : à partir de 35€ — le tarif varie selon la complexité de la clé et sa marque.",
            ],
        },
        block2: {
            img: IMG("entretien-regulier-serrurerie.webp"),
            kicker: "Clés protégées",
            title: "Carte de propriété et clés brevetées",
            paras: [
                "Certaines clés de haute sécurité sont protégées par brevet : leur reproduction exige la présentation de la carte de propriété fournie avec la serrure. Cette protection garantit qu'aucun double ne circule sans votre accord.",
                "Vous avez perdu votre carte de propriété ? Nous vous orientons vers la solution adaptée : déclaration auprès du fabricant ou remplacement du cylindre.",
            ],
        },
        note: "Double de clé : clé plate 5€, clé à gorges 11€, clé spéciale à partir de 35€. Présentez votre carte de propriété pour les clés protégées.",

        faq: [
            {
                q: "Peut-on reproduire n'importe quelle clé ?",
                a: "La plupart des clés plates, à gorges et à points se reproduisent facilement. Les clés dites « protégées » (Fichet F3D, Vachette Radial NT, Mul-T-Lock MT5+, Abloy Protec2) ne peuvent être reproduites que sur présentation de la carte de propriété délivrée à l'achat. Ce système garantit qu'aucun double ne peut être fait à votre insu.",
            },
            {
                q: "Combien de doubles de clé me faut-il ?",
                a: "Pour un logement, nous recommandons 2 doubles par utilisateur régulier (domicile + lieu de travail ou chez un proche de confiance). Avoir un double chez un voisin de confiance évite 80 % des situations d'urgence après une perte de clé.",
            },
            {
                q: "Quelle est la différence entre une clé plate et une clé spéciale ?",
                a: "Une clé plate (profil simple) se reproduit pour 5 à 11 €. Une clé spéciale intègre des protections supplémentaires : code codé, profil asymétrique, puce électronique. Sa reproduction nécessite un équipement spécifique et une carte de propriété, et coûte à partir de 35 €.",
            },
            {
                q: "J'ai perdu ma carte de propriété, puis-je quand même avoir un double ?",
                a: "Pour les clés non protégées, pas de problème. Pour les clés protégées par brevet (Fichet, Vachette Radial, etc.), il faut contacter le fabricant avec la référence du cylindre pour obtenir un duplicata de la carte. Alternativement, le remplacement du cylindre avec un nouveau jeu de clés est souvent la solution la plus rapide.",
            },
        ],
    },
];
